__turbopack_context__.v({
  "currentSelection": "styleSelector-module-scss-module__QK94Fa__currentSelection",
  "dropdownArrow": "styleSelector-module-scss-module__QK94Fa__dropdownArrow",
  "dropdownMenu": "styleSelector-module-scss-module__QK94Fa__dropdownMenu",
  "itemLabel": "styleSelector-module-scss-module__QK94Fa__itemLabel",
  "menuContent": "styleSelector-module-scss-module__QK94Fa__menuContent",
  "menuItem": "styleSelector-module-scss-module__QK94Fa__menuItem",
  "selectedItem": "styleSelector-module-scss-module__QK94Fa__selectedItem",
  "selectorContainer": "styleSelector-module-scss-module__QK94Fa__selectorContainer",
  "selectorWrapper": "styleSelector-module-scss-module__QK94Fa__selectorWrapper",
  "trianglePointer": "styleSelector-module-scss-module__QK94Fa__trianglePointer",
  "triggerButton": "styleSelector-module-scss-module__QK94Fa__triggerButton",
});
